const ACTIVE = 'active'
const PENDING = 'pending'
const CLOSED = 'closed'

export const getPartnerStatus = (partner) => {
  const connectionStatus = partner.membership?.status
  return {
    isConnected: connectionStatus === ACTIVE,
    isPending: connectionStatus === PENDING,
    isClosed: connectionStatus === CLOSED,
    connectionStatus,
  }
}

export const getButtonText = (partner, t) => {
  const {connectionStatus} = getPartnerStatus(partner)

  const buttonContext = connectionStatus || partner.status

  return t('points:redemptionPartnerScreen.buttonLabel', {
    context: buttonContext,
  })
}

export const getButtonActions = (partner) => {
  const {isConnected, isPending} = getPartnerStatus(partner)

  return {
    shouldShowRedeemButton: isConnected,
    redeemButtonDisabled: partner.status !== 'enabled',
    isConnectButtonDisabled: isPending || partner.status !== 'enabled',
  }
}
